/* global loadJS, LazyLoad */
(function () {
  var classList = document.documentElement.classList;

  function loadLazyLoad() {
    loadJS('/js/lazyload/lazyload.min.js', function () {
      return new LazyLoad({
        elements_selector: '.lazy'
      });
    });
  }

  if (classList.contains('no-promises')) {
    loadJS('/js/polyfills/polyfill.min.js', true);
  }
  /*
  if (classList.contains('no-objectfit')) {
      loadJS('/js/polyfills/objectFitPolyfill.min.js', true)
  }
  */


  if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window) || !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    document.documentElement.classList.add('no-intersectionobserver');
    loadJS('/js/polyfills/intersection-observer.js', loadLazyLoad);
  } else {
    document.documentElement.classList.add('intersectionobserver');
    loadLazyLoad();
  }
  /*
  if (classList.contains('no-fetch')) {
      loadJS('/js/polyfills/fetch.umd.js')
  }
  */

})();
require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.parse-int");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.set");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.search");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

require("core-js/modules/web.timers");

/*! instant.page v5.1.0 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */
var mouseoverTimer;
var lastTouchTimestamp;
var prefetches = new Set();
var prefetchElement = document.createElement('link');
var isSupported = prefetchElement.relList && prefetchElement.relList.supports && prefetchElement.relList.supports('prefetch') && window.IntersectionObserver && 'isIntersecting' in IntersectionObserverEntry.prototype;
var allowQueryString = ('instantAllowQueryString' in document.body.dataset);
var allowExternalLinks = ('instantAllowExternalLinks' in document.body.dataset);
var useWhitelist = ('instantWhitelist' in document.body.dataset);
var mousedownShortcut = ('instantMousedownShortcut' in document.body.dataset);
var DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111;
var delayOnHover = 65;
var useMousedown = false;
var useMousedownOnly = false;
var useViewport = false;

if ('instantIntensity' in document.body.dataset) {
  var intensity = document.body.dataset.instantIntensity;

  if (intensity.substr(0, 'mousedown'.length) == 'mousedown') {
    useMousedown = true;

    if (intensity == 'mousedown-only') {
      useMousedownOnly = true;
    }
  } else if (intensity.substr(0, 'viewport'.length) == 'viewport') {
    if (!(navigator.connection && (navigator.connection.saveData || navigator.connection.effectiveType && navigator.connection.effectiveType.includes('2g')))) {
      if (intensity == "viewport") {
        /* Biggest iPhone resolution (which we want): 414 × 896 = 370944
         * Small 7" tablet resolution (which we don’t want): 600 × 1024 = 614400
         * Note that the viewport (which we check here) is smaller than the resolution due to the UI’s chrome */
        if (document.documentElement.clientWidth * document.documentElement.clientHeight < 450000) {
          useViewport = true;
        }
      } else if (intensity == "viewport-all") {
        useViewport = true;
      }
    }
  } else {
    var milliseconds = parseInt(intensity);

    if (!isNaN(milliseconds)) {
      delayOnHover = milliseconds;
    }
  }
}

if (isSupported) {
  var eventListenersOptions = {
    capture: true,
    passive: true
  };

  if (!useMousedownOnly) {
    document.addEventListener('touchstart', touchstartListener, eventListenersOptions);
  }

  if (!useMousedown) {
    document.addEventListener('mouseover', mouseoverListener, eventListenersOptions);
  } else if (!mousedownShortcut) {
    document.addEventListener('mousedown', mousedownListener, eventListenersOptions);
  }

  if (mousedownShortcut) {
    document.addEventListener('mousedown', mousedownShortcutListener, eventListenersOptions);
  }

  if (useViewport) {
    var triggeringFunction;

    if (window.requestIdleCallback) {
      triggeringFunction = function triggeringFunction(callback) {
        requestIdleCallback(callback, {
          timeout: 1500
        });
      };
    } else {
      triggeringFunction = function triggeringFunction(callback) {
        callback();
      };
    }

    triggeringFunction(function () {
      var intersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var linkElement = entry.target;
            intersectionObserver.unobserve(linkElement);
            preload(linkElement.href);
          }
        });
      });
      document.querySelectorAll('a').forEach(function (linkElement) {
        if (isPreloadable(linkElement)) {
          intersectionObserver.observe(linkElement);
        }
      });
    });
  }
}

function touchstartListener(event) {
  /* Chrome on Android calls mouseover before touchcancel so `lastTouchTimestamp`
   * must be assigned on touchstart to be measured on mouseover. */
  lastTouchTimestamp = performance.now();
  var linkElement = event.target.closest('a');

  if (!isPreloadable(linkElement)) {
    return;
  }

  preload(linkElement.href);
}

function mouseoverListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return;
  }

  var linkElement = event.target.closest('a');

  if (!isPreloadable(linkElement)) {
    return;
  }

  linkElement.addEventListener('mouseout', mouseoutListener, {
    passive: true
  });
  mouseoverTimer = setTimeout(function () {
    preload(linkElement.href);
    mouseoverTimer = undefined;
  }, delayOnHover);
}

function mousedownListener(event) {
  var linkElement = event.target.closest('a');

  if (!isPreloadable(linkElement)) {
    return;
  }

  preload(linkElement.href);
}

function mouseoutListener(event) {
  if (event.relatedTarget && event.target.closest('a') == event.relatedTarget.closest('a')) {
    return;
  }

  if (mouseoverTimer) {
    clearTimeout(mouseoverTimer);
    mouseoverTimer = undefined;
  }
}

function mousedownShortcutListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return;
  }

  var linkElement = event.target.closest('a');

  if (event.which > 1 || event.metaKey || event.ctrlKey) {
    return;
  }

  if (!linkElement) {
    return;
  }

  linkElement.addEventListener('click', function (event) {
    if (event.detail == 1337) {
      return;
    }

    event.preventDefault();
  }, {
    capture: true,
    passive: false,
    once: true
  });
  var customEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false,
    detail: 1337
  });
  linkElement.dispatchEvent(customEvent);
}

function isPreloadable(linkElement) {
  if (!linkElement || !linkElement.href) {
    return;
  }

  if (useWhitelist && !('instant' in linkElement.dataset)) {
    return;
  }

  if (!allowExternalLinks && linkElement.origin != location.origin && !('instant' in linkElement.dataset)) {
    return;
  }

  if (!['http:', 'https:'].includes(linkElement.protocol)) {
    return;
  }

  if (linkElement.protocol == 'http:' && location.protocol == 'https:') {
    return;
  }

  if (!allowQueryString && linkElement.search && !('instant' in linkElement.dataset)) {
    return;
  }

  if (linkElement.hash && linkElement.pathname + linkElement.search == location.pathname + location.search) {
    return;
  }

  if ('noInstant' in linkElement.dataset) {
    return;
  }

  return true;
}

function preload(url) {
  if (prefetches.has(url)) {
    return;
  }

  var prefetcher = document.createElement('link');
  prefetcher.rel = 'prefetch';
  prefetcher.href = url;
  document.head.appendChild(prefetcher);
  prefetches.add(url);
}
require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    var elements = document.querySelectorAll("a[href^='mailto:']");

    if (elements.length > 0) {
      for (var index in elements) {
        var element = elements[index];

        if (element instanceof Node) {
          element.setAttribute('href', element.getAttribute('href').replace(/(#zavinac#)/ig, '@'));
          element.innerHTML = element.innerHTML.replace(/(#zavinac#)/ig, '@');
        }
      }
    }
  }
})();
/* global toastr */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    document.body.classList.add('site-onready'); // setToastrDefaults()
    // showFlashMessages()
  }
  /*function setToastrDefaults() {
      if (Object.prototype.hasOwnProperty.call(window, 'toastr')) {
          toastr.options = {'closeButton': true, 'progressBar': true}
      }
  }*/

  /*function showFlashMessages() {
      if (
          window._cmsFlashMessages !== undefined &&
          Array.isArray(window._cmsFlashMessages) &&
          window._cmsFlashMessages.length > 0
      ) {
          for (var index in window._cmsFlashMessages) {
              var item = window._cmsFlashMessages[index]
              switch (item.type) {
                  case 'success':
                      toastr.success(item.message)
                      break
                  case 'error':
                      toastr.error(item.message)
                      break
                  case 'warning':
                      toastr.warning(item.message)
                      break
                  default:
                      toastr.info(item.message)
              }
          }
          window._cmsFlashMessages = []
      }
  }*/


  window.dataLayer = window.dataLayer || [];
})();
/* global SmoothScroll */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    if (SmoothScroll !== undefined) {
      /* eslint-disable-next-line no-unused-vars */
      var scroll = new SmoothScroll('a[data-scroll][href*="#"]');
    }
  }
})();
require("core-js/modules/web.timers");

(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  var tm;
  var prevPosition = 0;
  var position = 0;

  function checkStickyMenu() {
    position = window.pageYOffset;
    var body = document.body;
    var isActive = body.classList.contains('sticky-header');

    if (position > 150) {
      if (!isActive) {
        body.classList.add('sticky-header-no-transition');
        setTimeout(function () {
          body.classList.remove('sticky-header-no-transition');
        }, 50);
        body.classList.add('sticky-header');
      }

      if (position - prevPosition < 0 && isActive) {
        body.classList.add('sticky-header-up');
      } else {
        body.classList.remove('sticky-header-up');
      }
    } else {
      body.classList.remove('sticky-header-no-transition');
      body.classList.remove('sticky-header');
      body.classList.remove('sticky-header-up');
    }

    prevPosition = position;
  }

  function run() {
    document.addEventListener('scroll', function (event) {
      clearTimeout(tm);
      tm = setTimeout(checkStickyMenu, 25);
    });
    checkStickyMenu();
  }
})();
/* global loadJS */
window.jQuery(function () {
  var $ = window.jQuery;
  $.nette.init();
  $('body').on('click', '.confirm', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var text = $(this).data('confirm-text');

    if (confirm(text ? '' + text : $('html').attr('lang') === 'cs' ? 'Opravdu smazat tento záznam?' : 'Do you really want to delete this record?')) {
      document.location = $(this).attr('href');
    }
  });

  if ($('#ajaxSpinner').length > 0) {
    $(document).on('ajaxStart', function () {
      $('#ajaxSpinner').addClass('loading');
    });
    $(document).on('ajaxStop', function () {
      $('#ajaxSpinner').removeClass('loading');
    });
  }

  $.nette.ext({
    before: function before() {
      $('form.ajax').addClass('loading');
    },
    complete: function complete() {
      $('form.ajax').removeClass('loading');
    }
  }); // DYNAMIC GRECAPTCHA LOADER

  var grecaptchaLoading = false;

  if ($('form .g-recaptcha').length > 0) {
    if (window.grecaptcha === undefined) {
      $('form input').on('focus', function () {
        if (!grecaptchaLoading && window.grecaptcha === undefined) {
          grecaptchaLoading = true;
          loadJS('/js/recaptcha/recaptcha.invisible.ajax.js', function () {
            grecaptchaLoading = false;
          });
        }
      });
    }
  }
});
require("core-js/modules/es.array.find");

require("core-js/modules/web.timers");

window.jQuery(function () {
  var $ = window.jQuery;
  var tm;
  var rTm;
  var mediaQueryMatch = false;
  var mediaQueryList = window.matchMedia('(min-width: 992px)');
  var mobileMenuOpen = false;
  var pTm;

  try {
    mediaQueryList.addEventListener('change', onMediaQueryChange);
  } catch (err) {
    $(window).on('resize', function () {
      clearTimeout(pTm);
      pTm = setTimeout(function () {
        onMediaQueryChange(window.matchMedia('(min-width: 992px)'));
      }, 25);
    });
  }

  onMediaQueryChange(mediaQueryList); // Mobilní toggle

  $('button.dropdown-mobile-toggle').on('click', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if ($(this).parent().attr('aria-expanded') === 'true') {
      $(this).parent().attr('aria-expanded', 'false').parent().find('.dropdown-menu').first().removeClass('show');
    } else {
      $(this).parent().attr('aria-expanded', 'true').parent().find('.dropdown-menu').first().addClass('show');
    }
  });

  function onMediaQueryChange(queryList) {
    var oldValue = !!mediaQueryMatch;
    mediaQueryMatch = queryList.matches === true;

    if (oldValue !== mediaQueryMatch) {
      resetTimeouts();

      if (oldValue) {
        $('.mega-dropdown-dropdown-toggle').attr('aria-expanded', 'true');
      } else {
        $('.mega-dropdown-dropdown-toggle').attr('aria-expanded', 'false');
      }
    }

    if (mediaQueryMatch) {
      $('html').removeClass('mobile-menu-open');
    } else {
      if (mobileMenuOpen) {
        $('html').addClass('mobile-menu-open');
      }
    }
  }

  $('.navbar-toggler').on('click', function () {
    $('html').toggleClass('mobile-menu-open');
    mobileMenuOpen = $('html').hasClass('mobile-menu-open');
    resetDropdowns();
  });

  function attachListeners() {
    $('.navbar-pb .nav-item.dropdown.position-static > [data-toggle="dropdown"]').on('mouseenter mouseover focus', setDisplayTimeout);
    $('.navbar-pb').on('mouseleave', setResetDropdownsTimeout);
    $('.navbar-pb .dropdown-menu').on('mouseenter', resetTimeouts);
    $('body > .main-content').on('click mouseenter', setResetDropdownsTimeout);
    $('.navbar-pb .top-level-link').on('mouseenter', setResetDropdownsTimeout);
    $('.navbar-pb .nav-item.dropdown.position-static > [data-toggle="dropdown"]').on('click', fixUnderlay);
    $('.navbar-pb .nav-item.dropdown.position-static > [data-toggle="dropdown"] .dropdown-toggle-text').on('click', fixUnderlay);
  }

  function resetTimeouts() {
    clearTimeout(tm);
    clearTimeout(rTm);
  }

  function setResetDropdownsTimeout() {
    if (mediaQueryMatch) {
      clearTimeout(rTm);
      rTm = setTimeout(function () {
        resetDropdowns();
      }, 50);
    }
  }

  function resetDropdowns() {
    $('.navbar-pb [data-toggle="dropdown"][aria-expanded="true"]').attr('aria-expanded', 'false');
    $('.navbar-pb .dropdown-menu.show').removeClass('show');
    $('#__menuUnderlay').addClass('d-none');
  }

  function fixUnderlay(event) {
    window.setTimeout(function () {
      if ($(event.target).hasClass('dropdown-toggle-text')) {
        event.target = $(event.target).parent().get(0);
      }

      $('#__menuUnderlay').addClass('d-none');

      if (mediaQueryMatch) {
        if ($(event.target).attr('aria-expanded') === 'true') {
          var container = $(event.target).parent().find('.dropdown-menu > .container').first();
          $('#__menuUnderlay').attr('style', 'min-height: ' + container.outerHeight() + 'px;').removeClass('d-none');
        }
      }
    }, 30);
  }

  function setDisplayTimeout(event) {
    if (mediaQueryMatch) {
      if ($('.navbar-pb .dropdown-menu.show').length > 0) {
        tm = setTimeout(function () {
          displayDropdown(event);
        }, 50);
      } else {
        displayDropdown(event);
      }
    }
  }

  function displayDropdown(event) {
    if (mediaQueryMatch) {
      if ($(event.target).attr('aria-expanded') === 'false') {
        resetDropdowns();
        $(event.target).attr('aria-expanded', 'true').parent().find('.dropdown-menu').first().addClass('show');
        var container = $(event.target).attr('aria-expanded', 'true').parent().find('.dropdown-menu > .container').first();
        $('#__menuUnderlay').attr('style', 'min-height: ' + container.outerHeight() + 'px;').removeClass('d-none');
      }
    }
  }

  attachListeners();
});
window.jQuery(function () {
  if (typeof $('body').lightGallery === 'function' && $('[data-gallery]').length > 0) {
    $('[data-gallery]').each(function () {
      var wrapper = $(this);
      var options = wrapper.data('gallery') !== '' ? wrapper.data('gallery') : {};
      wrapper.lightGallery(options);
    });
  }
});
window.jQuery(function () {
  var $ = window.jQuery;
  var input = document.getElementById('__searchInput');
  $.get(input.dataset.awesompleteUrl, {}, function (response) {
    window.searchAutocomplete = new window.Awesomplete(input, {
      minChars: 3,
      maxItems: 5,
      autoFirst: true,
      list: response
    });
  });
  $('#__searchInput').parents('form').first().on('awesomplete-selectcomplete', function (event) {
    $('#__searchInput').parents('form').first().submit();
  });
});
/* global Flickity */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function forceLoadImages(selector) {
    var images = document.querySelectorAll(selector + ' img[data-src].lazy');

    for (var index in images) {
      var img = images[index];

      if (img instanceof Node) {
        if (img.dataset.wasProcessed !== 'true') {
          img.setAttribute('src', img.dataset.src);
          img.dataset.wasProcessed = 'true';
        }
      }
    }
  }

  function initVdSlidersFlickity() {
    var elements = document.querySelectorAll('.plast-slider');
    forceLoadImages('.plast-slider');
    var instances = [];

    for (var index in elements) {
      var element = elements[index];

      if (element instanceof Node) {
        instances.push({
          element: element,
          flickity: new Flickity(element, {
            cellAlign: 'center',
            contain: true,
            autoPlay: element.dataset.autoplay ? element.dataset.autoplayDelay : false,
            pageDots: element.dataset.pageDots === 'true',
            prevNextButtons: element.dataset.navigationButtons === 'true',
            imagesLoaded: true,
            cellSelector: '.plast-slider-slide',
            arrowShape: 'M99 43.81V56.2H24.76L58.79 90.2 50 99 1 50 50 1l8.79 8.79L24.76 43.8z'
          })
        });
      }
    }

    return instances;
  }

  function run() {
    if (window.Flickity !== undefined) {
      // initAspenaReferencesFlickity()
      initVdSlidersFlickity();
    }
  }
})();
require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.iterator");

require("core-js/modules/web.timers");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  var tm;
  window.addEventListener('resize', timeoutHandler);
  window.addEventListener('orientationchange', timeoutHandler);
  window.addEventListener('canplay', function (event) {
    if (event.target.getAttribute('autoplay') !== null) {
      event.target.play();
    }
  });

  function timeoutHandler() {
    clearTimeout(tm);
    tm = setTimeout(function () {
      run();
    }, 50);
  }

  function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  }

  function run() {
    var videos = document.querySelectorAll('[data-bg-video]');

    if (videos && videos.length > 0) {
      if (window.matchMedia('(min-width: 768px)').matches) {
        var _iterator = _createForOfIteratorHelper(videos),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var element = _step.value;

            if (element.querySelectorAll('video').length === 0) {
              element.insertBefore(createElementFromHTML(element.dataset.bgVideo), element.firstChild || null);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }
})();